<template>
  <div class="wrapper main-container">
    <!-- 平台活动 -->
    <div class="content">
      <div class="top" v-if="$units.pointAction('commission_30_1') && userType != 3">
        <div class="btn" @click="hanldeActiveConfig">
          <span>新增活动预设比例</span>
        </div>
        <div class="txt">
          新活动预设服务费比例开启后，如果您未单独对活动产品配置服务费比例，则即将开始的无门槛活动产品都将按照新活动预设活动比例生效，进行中或已结束按照原配置比例不变。
        </div>
      </div>
      <Tabs v-model="tabNum" @on-click="checkTabs">
        <TabPane label="进行中" name="2"></TabPane>
        <TabPane label="未开始" name="1"></TabPane>
        <TabPane label="已结束" name="3"></TabPane>
      </Tabs>
      <loading :isShow="loading" />
      <div
        class="list"
        v-for="(item, index) in activeList"
        :key="index"
        @click="openPageTabTags('/activityManage/detail', { id: item.actId, mode: item.mode, actType: item.actType })"
      >
        <div class="item">
          <div class="left">
            <div class="imgbox">
              <img :src="item.img" alt />
              <div class="mask" v-if="tabNum == 3">活动已结束</div>
            </div>
            <div class="txtBox">
              <h1>{{ item.title }}</h1>
              <p>
                <tooltip :txt-info="item.description"></tooltip>
              </p>
              <p class="actTime">活动时间：{{ item.startTime }} 至 {{ item.endTime }}</p>
              <div class="time">
                <span class="text3" v-if="item.timeStatus == 0">距离开始还剩：</span>
                <span class="text3" v-if="item.timeStatus == 1">距离结束还剩：</span>
                <span class="text4" v-if="item.timeStatus == 0 || item.timeStatus == 1">{{ item.timeText }}</span>
              </div>
            </div>
            <div class="status unStart" v-if="tabNum == 1">未开始</div>
            <div class="status starting" v-else-if="tabNum == 2">进行中</div>
            <div class="status end" v-else>已结束</div>
          </div>

          <div class="right" v-if="tabNum == 2 || tabNum == 3">
            <div class="time-product">
              <span>活动时间：{{ filterTime(item.startTime, 'YYYY-MM-DD') }} 至 {{ filterTime(item.endTime, 'YYYY-MM-DD') }}</span>
              <div class="product">
                <span class="title" v-if="item.actType != 4">活动产品（共{{ (item.productList && item.productList.length) || 0 }}款）</span>
                <div class="item">
                  <Tooltip :content="item.productList && item.productList.join('，')" placement="left-start" :always="false">
                    <span>{{ item.productList && item.productList.join('，') }}</span>
                  </Tooltip>
                  <div v-if="userType != 3 && item.mode == 1" class="btn" @click.stop="handleRewardDetail(item.actId)">单独配置奖励</div>
                </div>
              </div>
            </div>
          </div>

          <div class="right" v-else>
            <!-- 活动未开始 -->
            <div class="unStartBox lists" v-if="tabNum == 1">
              <h1 v-if="item.actType != 4">
                参加活动 (共
                <span v-if="item.productList">{{ item.productList.length }}</span>
                <span v-else>0</span>款)
              </h1>
              <Tooltip
                :content="item.productList && item.productList.join('，')"
                placement="left-start"
                :always="false"
                v-if="item.productList && item.productList.length != 0"
              >
                <p>{{ item.productList.join('、') }}</p>
              </Tooltip>
              <div v-if="userType != 3 && item.mode == 1" class="btn" @click.stop="handleRewardDetail(item.actId)">单独配置奖励</div>
            </div>
            <div class="lists lists1" v-else>
              <div class="items">
                <div class="txt" v-if="item.statistics">{{ item.statistics.policyCount }}</div>
                <div class="txt" v-else>{{ 0 }}</div>
                <div class="tip">
                  <span>
                    保单总计(个)
                    <Poptip trigger="hover" class="tipBox">
                      <span class="iconfont iconwenhao" style="color: #b1b5b9"></span>
                      <div slot="content">活动中，当前账户和所有下级机构团队的保单数（不含退保撤单）</div>
                    </Poptip>
                  </span>
                </div>
              </div>
              <div class="items">
                <div class="txt" v-if="item.statistics">{{ item.statistics.orgNetIncome }}</div>
                <div class="txt" v-else>{{ 0 }}</div>
                <div class="tip">
                  <span>
                    机构净收入(元)
                    <Poptip trigger="hover" class="tipBox">
                      <span class="iconfont iconwenhao" style="color: #b1b5b9"></span>
                      <div slot="content" v-if="userType != 3">活动期间内，当前机构已承保保单的净收入（含活动奖励不含撤单、退保扣减）</div>
                      <div slot="content" v-else>活动期间内，当前机构已承保保单的净收入（不含撤单、退保扣减）</div>
                    </Poptip>
                  </span>
                </div>
              </div>
              <div class="items" v-if="userType != 3">
                <div class="txt" v-if="item.statistics">{{ item.statistics.companyReward }}</div>
                <div class="txt" v-else>{{ 0 }}</div>
                <div class="tip">
                  <span>
                    机构奖励(元)
                    <Poptip trigger="hover" class="tipBox">
                      <span class="iconfont iconwenhao" style="color: #b1b5b9"></span>
                      <div slot="content">活动期间内，当前机构获得的活动奖励（不含撤单、退保）</div>
                    </Poptip>
                  </span>
                </div>
              </div>
              <div class="items">
                <div class="txt" v-if="item.statistics">{{ item.statistics.agencyReward }}</div>
                <div class="txt" v-else>{{ 0 }}</div>
                <div class="tip">
                  <span>
                    业务员奖励(元)
                    <Poptip trigger="hover" class="tipBox">
                      <span class="iconfont iconwenhao" style="color: #b1b5b9"></span>
                      <div slot="content">活动期间内，当前账户及下级所有业务员获得的活动奖励（不含撤单、退保）</div>
                    </Poptip>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty" v-if="activeList.length == 0">
        <p>
          <img src="@static/images/noData.png" style="width: 290px" />
        </p>
        <p>
          <span>暂无数据</span>
        </p>
      </div>
      <div class="pageBox">
        <Page :total="allData.total" :current="pageNo" :page-size="allData.size" show-total @on-change="pageChange" style="text-align: center" />
      </div>
    </div>

    <Modal v-model="showAct" @on-ok="confirmAct" width="940" class="actBox">
      <div slot="header" class="actBoxHeader">
        <h1>新增活动预设比例</h1>
        <i-switch size="large" v-model="merchanConfList.status" />
      </div>
      <div class="top">
        <div class="tableBox">
          <table>
            <thead>
              <td></td>
              <td>服务费比例(%)</td>
            </thead>
            <tr>
              <td style="width: 55%">机构活动奖励 = 活动总奖励 x</td>
              <td>
                <InputNumber
                  :precision="2"
                  :min="0"
                  :max="100"
                  :active-change="false"
                  v-model="merchanConfList.orgReward"
                  style="width: 160px"
                  :disabled="!merchanConfList.status"
                />
              </td>
            </tr>
          </table>
        </div>
        <div class="tableBox">
          <table>
            <thead>
              <td></td>
              <td>服务费比例(%)</td>
            </thead>
            <tr>
              <td style="width: 55%">业务员活动奖励 = 活动总奖励 x</td>
              <td>
                <InputNumber
                  :precision="2"
                  :min="0"
                  :max="100"
                  :active-change="false"
                  v-model="merchanConfList.salesReward"
                  style="width: 160px"
                  :disabled="!merchanConfList.status"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="tip">
        注：新活动预设服务费比例开启后，如果您未单独对活动产品配置服务费比例，则即将开始的无门槛活动产品都将按照新活动预设活动比例生效，进行中或已结束按照原配置比例不变。
      </div>
    </Modal>
    <!-- 单独配置奖励 -->
    <Modal v-model="showOther" @on-ok="confirmOther" width="940" class="otherBox">
      <div slot="header" class="actBoxHeader">
        <h1>单独配置奖励</h1>
      </div>
      <loading :isShow="modaLoading" />
      <div class="content" v-for="(reward, r) in rewardDetailList" :key="r">
        <div class="title">
          <span>{{ reward.productType | filterProductType }}</span>
          <span>{{ reward.productName }}</span>
        </div>
        <div class="tableBox setTable">
          <Table :columns="columns" :data="reward.commissions">
            <template slot-scope="{ row }" slot="totalReward">
              <div>{{ row.totalReward.commission? row.totalReward.commission: '-' }}</div>
            </template>
            <template slot-scope="{ index }" slot="companyReward">
              <div>
                {{
                  reward.commissions[index].totalReward.commission?(reward.commissions[index].companyReward.commission = (reward.commissions[index].totalReward.commission - reward.commissions[index].salesReward.commission).toFixed(2)):'-'
                }}
              </div>
            </template>
            <template slot-scope="{ index }" slot="action">
              <div class="actionBox">
                <span
                  v-if="reward.commissions[index].totalReward.commission"
                  class="subtraction"
                  @click="subtraction(reward.commissions[index])"
                  :class="{ notAllow: reward.commissions[index].salesReward.commission <= 0 }"
                  >-</span
                >
                <InputNumber
                  :disabled='reward.commissions[index].totalReward.commission?false:true'
                  :precision="2"
                  :min="0"
                  :max="reward.commissions[index].totalReward.commission"
                  v-model="reward.commissions[index].salesReward.commission"
                  style="width: 160px; margin: 0 10px"
                />
                <span
                  v-if="reward.commissions[index].totalReward.commission"
                  class="add"
                  @click="add(reward.commissions[index])"
                  :class="{ notAllow: reward.commissions[index].salesReward.commission >= reward.commissions[index].totalReward.commission }"
                  >+</span
                >
              </div>
            </template>
          </Table>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import tooltip from '@/components/commons/tooltip';
import { filterTime } from '@/api/filter';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data() {
    return {
      filterTime,
      loading: false,
      modaLoading: false,
      tabNum: '2',
      showAct: false,
      showOther: false,
      value: null,
      pageNo: 1,
      pageSize: 10,
      activeList: [], // 活动列表数据
      rewardDetailList: [], //奖励详情列表
      merchanConfList: {}, // 活动预设列表
      activeid: '', // 活动id
      allData: {},
      userType: '',
      columns: [
        {
          title: '保障期',
          key: 'guaranteeDesc',
          align: 'center'
        },

        {
          title: '交费期',
          key: 'payDesc',
          align: 'center'
        },
        {
          title: '活动总奖励(%)',
          key: 'totalReward',
          slot: 'totalReward',
          align: 'center'
        },
        {
          title: '机构奖励(%)',
          slot: 'companyReward',
          key: 'companyReward',
          align: 'center'
        },
        {
          title: '业务员奖励(%)',
          slot: 'action',
          key: 'salesReward',
          align: 'center',
          width: '260'
        }
      ]
    };
  },
  watch: {
    'merchanConfList.orgReward': {
      handler(val) {
        this.merchanConfList.salesReward = 100 - val * 1;
      }
    },
    'merchanConfList.salesReward': {
      handler(val) {
        this.merchanConfList.orgReward = 100 - val * 1;
      }
    }
  },
  components: {
    tooltip
  },
  computed: {},
  methods: {
    subtraction(row) {
      if (row.salesReward.commission <= 0) {
        return;
      }
      row.salesReward.commission = row.salesReward.commission * 1 - 1;
    },
    add(row) {
      if (row.salesReward.commission >= row.totalReward.commission) {
        return;
      }
      row.salesReward.commission = row.salesReward.commission * 1 + 1;
    },
    hanldeActiveConfig() {
      this.showAct = true;
      this.getMechanConfig();
    },
    // 获取活动预设
    getMechanConfig() {
      this.$http({
        url: '/buz/merchantConfig/read/detail',
        type: 'GET'
      }).then(res => {
        this.merchanConfList = res.data;
        this.merchanConfList.orgReward = Number(res.data.orgReward);
        this.merchanConfList.salesReward = Number(res.data.salesReward);
        this.merchanConfList.status = res.data.status == 1 ? true : false;
      });
    },
    //新增活动预设
    confirmAct() {
      this.$http({
        url: '/buz/merchantConfig/edit',
        type: 'POST',
        data: {
          id: this.merchanConfList.id,
          orgReward: this.merchanConfList.orgReward,
          salesReward: this.merchanConfList.salesReward,
          status: this.merchanConfList.status ? 1 : 0
        },
        apiPermissionCode: 'commission_30_1'
      }).then(res => {
        if (res.httpCode == 1) {
          this.$notice.success('操作成功');
        }
      });
    },
    // 分页
    pageChange(index) {
      this.pageNo = index;
      this.getActivityList();
    },
    // 奖励详情
    handleRewardDetail(id) {
      this.activeid = id;
      this.showOther = true;
      this.modaLoading = true;
      this.$http({
        url: '/buz/activity/commission/detail',
        type: 'GET',
        data: {
          id: id
        }
      })
        .then(res => {
          this.modaLoading = false;
          this.rewardDetailList = res.data;
          this.rewardDetailList.map(item => {
            item.commissions.map(resp => {
              resp.totalReward.commission = Number(resp.totalReward.commission);
              resp.companyReward.commission = Number(resp.companyReward.commission);
              resp.salesReward.commission = Number(resp.salesReward.commission);
            });
          });
        })
        .catch(e => {
          this.modaLoading = false;
        });
    },
    //单独配置
    confirmOther() {
      let item = [];
      this.rewardDetailList.map(res => {
        res.commissions.map(com => {
          item.push(com.companyReward);
          item.push(com.salesReward);
        });
      });
      this.$http({
        url: '/buz/actCommission/updateOrgCommission',
        type: 'post',
        data: {
          actId: this.activeid,
          items: item
        }
      })
        .then(res => {
          if (res.httpCode == 1) {
            this.$notice.success('修改成功');
          }
        })
        .catch(e => {});
    },
    //标签切换
    checkTabs() {
      this.pageNo = 1;
      this.getActivityList();
    },
    // 获取活动列表
    getActivityList() {
      this.loading = true;
      this.$http({
        url: '/buz/activity/org/list',
        type: 'post',
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          status: Number(this.tabNum)
        },
        apiPermissionCode: 'commission_30_0'
      })
        .then(res => {
          this.loading = false;
          this.allData = res;
          this.activeList = res.data;
          this.handleData();
        })
        .catch(e => {
          this.loading = false;
        });
    },
    // 接口返回数据处理
    handleData() {
      this.activeList.forEach(item => {
        this.getEndTime(item);
      });
    },
    // 设置倒计时时间
    getEndTime(item) {
      const now = new Date().getTime();
      const time = new Date(item.startTime).getTime();
      const eTime = new Date(item.endTime).getTime();
      if (eTime < now) {
        this.$set(item, 'timeStatus', '-1');
      } else if (time < now) {
        this.$set(item, 'timeStatus', '1');
        this.getTimeText(item, now, eTime);
      } else {
        this.$set(item, 'timeStatus', '0');
        this.getTimeText(item, now, time);
      }
    },
    //设置倒计时时间格式
    getTimeText(item, stiem, etime) {
      let text = '';
      const m = parseInt((etime - stiem) / 1000 / 60);
      if (parseInt((m / 60) % 24) != 0) {
        text = parseInt((m / 60) % 24) + '小时';
      }
      if (parseInt(m / 60 / 24) != 0) {
        text = parseInt(m / 60 / 24) + '天' + text;
      } else {
        text = text + parseInt(m % 60) + '分钟';
      }
      this.$set(item, 'timeText', text);
    }
  },
  filters: {
    filterProductType(val) {
      if (!val) {
        return '';
      } else if (val == 1) {
        return '长险';
      } else if (val == 2) {
        return '短险';
      }
    }
  },
  created() {
    this.userType = JSON.parse(localStorage.getItem('userInfo')).userType;
  },
  mounted() {
    this.getActivityList();
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
